import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ConstantesService } from '../constantes/constantes.service';
import { Sector } from '../modelos/sector';
import { Tipologia } from '../modelos/tipologia';
import { Estado } from '../modelos/estado';
import { Cliente } from '../modelos/cliente';
import { Sociedad } from '../modelos/sociedad';

@Injectable()
export class GeneralService {

    constructor(
        private http: HttpClient,
        private constantes: ConstantesService
    ) { }

    getSectores(): Observable<any> {
        return this.http.get<Sector[]>(environment.urlBase + 'sectores', this.constantes.httpOptions);
    }

    /* getTipologias(): Observable<any> {
        return this.http.get<Tipologia[]>(environment.urlBase + 'tipologias', this.constantes.httpOptions);
    } */
    
    // Tipologías según el sector
    getTipologias(id: number): Observable<any> {
        return this.http.get<Tipologia[]>(environment.urlBase + 'tipologiasDe/' + id, this.constantes.httpOptions);
    }

    getEstados(): Observable<any> {
        return this.http.get<Estado[]>(environment.urlBase + 'estados', this.constantes.httpOptions);
    }

    getClientes(): Observable<any> {
        return this.http.get<Cliente[]>(environment.urlBase + 'clientes', this.constantes.httpOptions);
    }

    getSociedades(): Observable<any> {
        // TODO: No implementada
        return this.http.get<Sociedad[]>(environment.urlBase + 'sociedades', this.constantes.httpOptions);
    }
    
    sendContactForm(formulario: any): Observable<any> {
        return this.http.post(environment.urlBase + 'reportproblem', formulario, this.constantes.httpOptions);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/services/general.service.ts